import sliceCreator from '../../index.js';
import {SUPER_ADMIN_DASHBOARD} from '../../../constants/index.js';
const _getSuperAdminDashboardAction = sliceCreator('SUPER_ADMIN_DASHBOARD', SUPER_ADMIN_DASHBOARD, 'get');
 
const { asyncAction: getSuperAdminDashboardAction, reducer, clearData: clearGetSuperAdminDashboardAction } = _getSuperAdminDashboardAction;
 
export default reducer;
 
export {
    getSuperAdminDashboardAction,
    clearGetSuperAdminDashboardAction,
}
 